
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-terms",
      function () {
        return require("private-next-pages/referral-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-terms"])
      });
    }
  